import React, { createContext, useState, useContext, useEffect } from 'react';

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [locale, setLocale] = useState('en');

  useEffect(() => {
    // Get locale from URL query parameter on initial load
    const queryParams = new URLSearchParams(window.location.search);
    const urlLocale = queryParams.get('locale');
    if (urlLocale) {
      setLocale(urlLocale);
    }

    // Listen for URL changes
    const handleUrlChange = () => {
      const params = new URLSearchParams(window.location.search);
      const newLocale = params.get('locale') || 'en';
      setLocale(newLocale);
    };

    window.addEventListener('popstate', handleUrlChange);
    return () => window.removeEventListener('popstate', handleUrlChange);
  }, []);

  return (
    <LanguageContext.Provider value={{ locale, setLocale }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
} 